import api from '../../api/index'

const buildingApiService = {
  async fetchBuilding (buildingId) {
    const urlEnd = `/v2/buildings/openLink/${buildingId}`
    const method = 'get'
    const response = await api.asyncRequest(urlEnd, method)
    return response.ok ? response.data : null
  },

  async fetchLogo (buildingId) {
    const urlEnd = `/v2/buildings/tripodLogo/${buildingId}`
    const method = 'get'
    const response = await api.asyncRequest(urlEnd, method)

    return response.ok ? response.data : null
  },

  async listBuildingsByUsername (username) {
    const urlEnd = '/v2/buildings/ListAll?limit=100&offset=0&skipLogin=true'
    const method = 'get'
    api.sendHeaders('iStaging-User-Username', username)
    const response = await api.asyncRequest(urlEnd, method)

    return response.ok ? response.data : null
  }
}

export default buildingApiService
